import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=7da08fbe&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
import style0 from "./upload.vue?vue&type=style&index=0&id=7da08fbe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da08fbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7da08fbe')) {
      api.createRecord('7da08fbe', component.options)
    } else {
      api.reload('7da08fbe', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=7da08fbe&scoped=true", function () {
      api.rerender('7da08fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadImg/upload.vue"
export default component.exports